export default class CheckRetrievedItemsFromSession {
	constructor({ elements }) {
		elements.forEach((el) => {
			if (el.dataset?.sessionKey) {
				const checkboxes = el.querySelectorAll('input[type=checkbox]');
				const items = CheckRetrievedItemsFromSession.retrieveItemsFromSession(
					el.dataset.sessionKey
				);
				CheckRetrievedItemsFromSession.checkSelectedItems(checkboxes, items);
				if (el.dataset?.sessionSecondaryKey) {
					const secondaryItems = CheckRetrievedItemsFromSession.retrieveItemsFromSession(
						el.dataset.sessionSecondaryKey
					);
					const itemsToToggle = el.querySelectorAll('[data-toggle-target]');
					CheckRetrievedItemsFromSession.showSelectedItems(itemsToToggle, secondaryItems);
				}
			}
		});
	}

	static showSelectedItems(items, secondaryItems) {
		items.forEach((item) => {
			if (secondaryItems.includes(item.dataset?.toggleTarget)) {
				item.classList.add('is-visible');
			}
		});
	}

	static checkSelectedItems(checkboxes, items) {
		checkboxes.forEach((checkbox) => {
			if (items.includes(checkbox.id)) {
				// eslint-disable-next-line no-param-reassign
				checkbox.checked = true;
			}
		});
	}

	static retrieveItemsFromSession(key) {
		const sessionStorageItem = sessionStorage.getItem(key);
		return sessionStorageItem !== null && sessionStorageItem !== undefined
			? Array.from(sessionStorage.getItem(key)?.split(','))
			: [];
	}
}
